import { useEffect, useRef } from 'react';

export function scrollToTop() {
  if (typeof window === 'undefined' || typeof window.scrollTo !== 'function') {
    return;
  }
  try {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  } catch {
    try {
      window.scrollTo(0, 0);
    } catch {
      return;
    }
  }
}

export function useFocusOnMount() {
  const ref = useRef(null);
  useEffect(() => {
    scrollToTop();
    try {
      ref.current?.focus({ preventScroll: true });
    } catch {
      ref.current?.focus();
    }
  }, []);
  return ref;
}
